import {
  mdiAccountCircle,
  mdiMonitor,
  mdiGithub,
  mdiLock,
  mdiAlertCircle,
  mdiSquareEditOutline,
  mdiTable,
  mdiViewList,
  mdiTelevisionGuide,
  mdiResponsive,
  mdiPalette,
  mdiReact
} from '@mdi/js'

export default [
  {
    to: '/dashboard',
    icon: mdiMonitor,
    label: 'Dashboard'
  },
  {
    to: '/devices',
    label: 'Devices',
    icon: mdiTable
  },
  {
    to: '/profile',
    label: 'Profile',
    icon: mdiAccountCircle
  },
  /*
  {
    label: 'Admin',
    icon: mdiViewList,
    menu: [
      {
        label: 'Create device'
      },
      {
        label: 'Register user'
      },
      {
        label: 'Create customer'
      }
    ]
  }
  */
]
